import cx from "classnames";
import Link from "next/link";
import { useTranslation } from "next-i18next";

import { LINKS } from "@/constants/links";

import header from "../header.module.css";
import { ShopSubmenu } from "./ShopSubMenu";
import sidebar from "./sidebar.module.css";

export const NavLinks = [
  {
    href: LINKS.WHAT_IS_PAFYLL,
    key: "navigation.what",
  },
  {
    href: LINKS.SHOP,
    key: "navigation.shop",
  },
  {
    href: LINKS.INSPIRATION,
    key: "navigation.articles",
  },
  {
    href: LINKS.FAQ,
    key: "navigation.faq",
  },
];

export const NavigationLinks = ({ menu = false }) => {
  const { t } = useTranslation("header");

  return (
    <ul className={cx(header.list, { [sidebar.nav]: menu })}>
      {NavLinks.map(({ href, key }) => {
        return (
          <li key={key} className={header.listItem}>
            {href === LINKS.SHOP ? (
              <ShopSubmenu title={t(key)} />
            ) : (
              <Link href={href}>{t(key)}</Link>
            )}
          </li>
        );
      })}
    </ul>
  );
};

export const Navigation = () => (
  <nav className={header.nav}>
    <NavigationLinks />
  </nav>
);
